export class Links {
    static readonly USER_GUIDE = "https://hexagongeospatial.fluidtopics.net/";
    static readonly SUPPORT = "https://supportsi.hexagon.com/help/s/?language=en_US";
}